import styled from '@emotion/styled'

import { mediaMax } from '@/styles/mixins'

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 120rem;
  margin: 4rem auto;
  padding: 0 15px;

  ${mediaMax.xs} {
    width: 90%;
  }
`

export const TextContainer = styled.div`
  width: ${({ isLarge }) => isLarge ? '100%' : '70%'};

  ${mediaMax.md} {
    width: 75%;
  }

  ${mediaMax.xs} {
    width: 90%;
  }
`

export const Headline = styled.h3`
  font-size: 4.5rem;
  line-height: 1.2;
  font-family: ${({ theme }) => theme.fonts.serif};
  color: ${({ theme }) => theme.colors.green2};
  font-weight: 400;
  text-align: ${({ alignment }) => `${alignment ?? 'left'}`};

  ${mediaMax.xs} {
    font-size: 4rem;
  }
`
